import React, { useContext, useState } from "react";
import {
    Button,
    FormField,
    StandardModalActionGroup,
    StandardModal,
    StandardModalDescription,
    StandardModalSection,
    StandardModalSectionTitle
} from "src/components";
import { TextLabel } from "../style";
import AddContacts from "./AddContacts";
import { EmailCampaignsContext } from "../../EmailCampaignsContext";

export default function NewAudience() {
    const {
        openCreateNewAudience,
        toggleAddSingleContact,
        uploadedCsvData,
        setUploadedCsvData,
        audienceName,
        setAudienceName,
        cancelCreateNewAudience
    } = useContext(EmailCampaignsContext);
    const [errors, setErrors] = useState({});

    // Manual validation
    const validate = () => {
        const newErrors = {};
        if (!audienceName.trim()) newErrors.audienceName = "Audience name is required";
        if (!uploadedCsvData || !uploadedCsvData.length > 0) newErrors.contact = "At least one contact must be added";
        return newErrors;
    };

    const onChangeAudienceName = (e) => {
        setAudienceName(e.target.value);
        setErrors((prevErrors) => ({ ...prevErrors, audienceName: "" }));
    };
    const onSubmit = () => {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors); // display errors
            return;
        }
    };

    return (
        <StandardModal
            open={true}
            onClose={openCreateNewAudience}
            widthMode="medium"
            title="New Audience"
            description="Create a custom audience list to use in your email campaigns. Add individual users or upload a CSV file to build your list."
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        width="140px"
                        height="39px"
                        color="#000000"
                        border="1px solid #000"
                        onClick={() => cancelCreateNewAudience()}
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>

                    <Button
                        type="button"
                        width="140px"
                        height="39px"
                        color="#FFFFFF"
                        backgroundColor="#171A22"
                        border="1px solid #171A22"
                        onClick={() => onSubmit()}
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Save
                    </Button>

                </StandardModalActionGroup>
            )}
        >
            <>
                <StandardModalSection>
                    <StandardModalSectionTitle>
                        Set an Audience Name
                    </StandardModalSectionTitle>
                    <StandardModalDescription>
                        This will help you identify this list for future campaigns.
                    </StandardModalDescription>
                    <FormField
                        borderRadius="10px"
                        size="15px"
                        height="50px"
                        border={errors.audienceName ? "1px solid red" : "1px solid #D8DEEC"}
                        backgroundColor={"#FFFFFF 0% 0% no-repeat padding-box"}
                        boxShadow="0px 3px 6px #00000029"
                        opacity="1"
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={"e.g., Monthly Newsletter – Clients"}
                        placeholderColor="#808080"
                        showErrors={true}
                        maxLength="100"
                        value={audienceName}
                        name="audienceName"
                        onChange={onChangeAudienceName}
                    />
                    <TextLabel color="red" style={{ marginTop: -10 }}>
                        {errors.audienceName}
                    </TextLabel>
                </StandardModalSection>

                <AddContacts
                    toggleAddSingleContact={toggleAddSingleContact}
                    setCsvData={setUploadedCsvData}
                    errors={errors}
                    setErrors={setErrors}
                    audienceName={audienceName}
                    openCreateNewAudience={openCreateNewAudience}
                />
            </>
        </StandardModal>
    );
}
